import axios from './BaseService';

const EMAILS_URL = `${
    process.env.REACT_APP_API_URL || window._env_?.REACT_APP_API_URL
}/emails`;

export async function getEmailPreviews() {
    const response = await axios.get(`${EMAILS_URL}/previews`);
    return response.data;
}

export async function getEmailPreview(type) {
    const response = await axios.get(`${EMAILS_URL}/previews/${type}`);
    return response.data;
}

export async function sendTestEmail(type, email) {
    await axios.post(`${EMAILS_URL}/previews/${type}/send`, { email });
}
